import {createContext} from 'react'

export const CostAnalysisReportContext = createContext({
  costAnalysisReportList: [] as any,
  isLoading: false,
  filters: {} as any,
  onSearch: (searchValue: string) => {},
  onSortingChange: (sortBy: string, sortOrder: string) => {},
})
